export default "__VITE_ASSET__edc8a41d__"